import { evaluate } from "mathjs";

export const isNumber = (str : string) => {

    try {
        const value = evaluate(str);

        if (isNaN(value)) {
            return { 
                ok: false, 
                title: '¡Cuidado!',
                msg: 'No has ingresado una respuesta'
            }
        } else {
            return { 
                ok: true, 
                title: 'Exito',
                msg: `${str} es un número`
            }
        }
        
    } catch (error) {
        return { 
            ok: false, 
            title: '¡Cuidado!',
            msg: 'No has ingresado una respuesta'
        }
    }
}

export const equalNumbers = (numberDataBase: string, numberUser: string) => {

    const numero = evaluate(numberDataBase);
    const numeroUsuario = evaluate(numberUser);

    if (numero === numeroUsuario) {
        return { 
            ok: true, 
            title: 'Exito',
            msg: 'Los números son iguales'
        }
    } else {
        return { 
            ok: false, 
            title: 'Error!',
            msg: 'Los números no son iguales'
        }
    }
}